import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconDevices = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Frame",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M19.5 8H21.5C22.0523 8 22.5 8.44772 22.5 9V21C22.5 21.5523 22.0523 22 21.5 22H13.5C12.9477 22 12.5 21.5523 12.5 21V20H4.5C3.94772 20 3.5 19.5523 3.5 19V3C3.5 2.44772 3.94772 2 4.5 2H18.5C19.0523 2 19.5 2.44772 19.5 3V8ZM17.5 8V4H5.5V18H12.5V9C12.5 8.44772 12.9477 8 13.5 8H17.5ZM14.5 10V20H20.5V10H14.5Z",
			fill: "#0587FB"
		})
	})
});
export default SvgIconDevices;
